module.exports = __webpack_public_path__ + "img/parceiro1.2b2e1b83.jpeg";